import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import {
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import SvgFaceBookIcon from "./share-icons/SvgFaceBookIcon";
import SvgTwiterIcone from "./share-icons/SvgTwiterIcone";
import SvgTelegramIcon from "./share-icons/SvgTelegramIcon";
import SvgWhatsAppIcon from "./share-icons/SvgWhatsAppIcon";
import Separator from "@/app/components/lib/Separator";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useIsClient from "@/hooks/useIsClient";
export enum ShareIconTypes {
  product = "product",
  blog = "blog",
}
interface props {
  startLabel?: string;
  type: ShareIconTypes;
}
const SocialShareBtns: React.FC<props> = ({ startLabel, type }) => {
  const mobile = useIsMobile();
  const t = useTranslation();
  const isClient = useIsClient();
  const getCompany = useGetCompanyQuery();
  const enableShareIcons =
    getCompany?.data?.result.theme.components.product
      .enable_product_share_icons;
  if (!enableShareIcons) return null;
  const shareUrl = isClient ? window?.location?.href : "";

  const shareIcons = [
    { Btn: TwitterShareButton, Icon: SvgTwiterIcone },
    { Btn: FacebookShareButton, Icon: SvgFaceBookIcon },
    { Btn: TelegramShareButton, Icon: SvgTelegramIcon },
    { Btn: WhatsappShareButton, Icon: SvgWhatsAppIcon },
  ];
  return (
    <div
      className="product-share-btns"
      style={type === ShareIconTypes.blog ? { margin: 0 } : {}}
    >
      <Separator
        secondary={mobile}
        startLabel={startLabel ?? t.share_product}
      />
      <div className="share-btns">
        {shareIcons.map(({ Btn, Icon }, index) => (
          <Btn key={index} url={shareUrl}>
            <div className="icon-container">
              <Icon />
            </div>
          </Btn>
        ))}
      </div>
    </div>
  );
};

export default SocialShareBtns;
